import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const Hba1cInputLogPage = lazy(() => import("./Hba1cInputLogPage"));

const Hba1cInputLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <Hba1cInputLogPage />
    </Suspense>
  );
};

export default Hba1cInputLogPageLazy;
